export const isWidgetMenuAction = (action) => action.position === "menu";
